import { z } from 'zod';

export const CREDIT_CAP = 90;

export type ReviewDecision = 'approve' | 'reject';

export interface ReviewFormValues {
  decision: ReviewDecision;
  officialCredits: number | null;
  officialFiles: { fileId: number; label?: string | null }[];
  reviewNote: string;
}

export const reviewDefaultValues: ReviewFormValues = {
  decision: 'approve',
  officialCredits: null,
  officialFiles: [],
  reviewNote: '',
};

export const reviewSchema = z
  .object({
    decision: z.enum(['approve', 'reject']),
    officialCredits: z
      .number()
      .int()
      .nonnegative()
      .max(CREDIT_CAP, { message: `Approved credits cannot exceed ${CREDIT_CAP}` })
      .nullable(),
    officialFiles: z.array(
      z.object({
        fileId: z.number().int().positive(),
        label: z.string().trim().optional().nullable(),
      })
    ),
    reviewNote: z.string().trim(),
  })
  .superRefine((data, ctx) => {
    if (data.decision === 'reject' && data.reviewNote.trim().length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'A review note is required to reject',
        path: ['reviewNote'],
      });
    }
    if (data.decision === 'approve') {
      if (data.officialCredits === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Official credits are required to approve',
          path: ['officialCredits'],
        });
      } else if (data.officialCredits <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Approved credits must be at least 1',
          path: ['officialCredits'],
        });
      }
    }
    if (data.decision === 'reject') {
      if (data.officialCredits !== null && data.officialCredits !== 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Rejected transcripts cannot carry credits. Set credits to 0 or clear them',
          path: ['officialCredits'],
        });
      }
    }
  });
